/* eslint-disable no-console */
import { I18n } from 'react-redux-i18n';

import React from 'react';
import SelectComponent from '../select/Select';

const TableUserFilter = props => (
  <React.Fragment>
    <div className={`d-flex flex-${props.isAllUsersPage ? 'row ' : 'row-reverse '} margin-top-10`}>
      <SelectComponent
        title="Filtrar por tipo:"
        value={props.type}
        body={[
          { name: 'Admin', value: 'admin' },
          { name: I18n.t('user'), value: 'store' },
        ].map(val => (<option key={val.value} value={val.value}>{val.name}</option>))}
        onChange={e => props.selectType(e.target.value)}
      />
      <div className="margin-left-10" />
      <SelectComponent
        title="Filtrar por status:"
        value={props.status}
        body={[
          { name: 'Ativo', value: 'active' },
          { name: I18n.t('inactive'), value: 'inactive' },
        ].map(val => (<option key={val.value} value={val.value}>{val.name}</option>))}
        onChange={e => props.selectStatus(e.target.value)}
      />
    </div>

  </React.Fragment>
);
export default TableUserFilter;
